import { render, staticRenderFns } from "./FacebookModalContent.vue?vue&type=template&id=dc86c47a&scoped=true"
import script from "./FacebookModalContent.vue?vue&type=script&lang=js"
export * from "./FacebookModalContent.vue?vue&type=script&lang=js"
import style0 from "./FacebookModalContent.vue?vue&type=style&index=0&id=dc86c47a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc86c47a",
  null
  
)

export default component.exports